import { Shield, PieChart, TrendingUp, Landmark, GraduationCap, Compass, UserCheck, Eye, Hourglass } from "lucide-react";

export const SERVICE_ICONS = { Shield, PieChart, TrendingUp, Landmark, GraduationCap };

export const SERVICE_ROUTES = [
  { slug: "insurance-advisory", label: "Insurance Advisory" },
  { slug: "mutual-fund-solutions", label: "Mutual Fund Solutions" },
  { slug: "investment-planning", label: "Investment Planning" },
  { slug: "wealth-management", label: "Wealth Management" },
  { slug: "financial-education", label: "Financial Education" },
];

export const TRUST_PILLARS = [
  { icon: Compass, title: "Professional Financial Guidance", text: "Structured, research-backed guidance delivered by people who explain the why behind every recommendation." },
  { icon: UserCheck, title: "Personalized Solutions", text: "Plans built around your income, goals, family and risk profile, never a one-size-fits-all product push." },
  { icon: Eye, title: "Transparent Recommendations", text: "Clear disclosure of costs, risks and our role in every conversation, so you always know where you stand." },
  { icon: Hourglass, title: "Long-Term Financial Planning", text: "We plan in decades, not quarters, with periodic reviews that keep your plan aligned with your life." },
];

export const APPROACH = [
  { step: "01", title: "Discover", text: "We understand your income, responsibilities, goals and comfort with risk." },
  { step: "02", title: "Analyse", text: "We assess protection gaps, savings rate, existing investments and time horizons." },
  { step: "03", title: "Plan", text: "You receive a clear, prioritised plan with transparent options and trade-offs." },
  { step: "04", title: "Review", text: "We revisit your plan periodically and whenever your life changes." },
];

export const SERVICE_OPTIONS = [
  "Insurance Advisory",
  "Mutual Fund Advisory",
  "Investment Solutions",
  "Wealth Management & Tax Planning",
  "Financial Education",
  "Retirement Planning",
  "General Financial Planning",
];

export const BUDGET_OPTIONS = [
  "Below ₹1 Lakh",
  "₹1 Lakh – ₹5 Lakh",
  "₹5 Lakh – ₹25 Lakh",
  "₹25 Lakh – ₹1 Crore",
  "Above ₹1 Crore",
  "Protection / insurance guidance only",
];

export const DISCLAIMER_SHORT =
  "Quantora Analytics Private Limited does not currently claim SEBI, IRDAI or AMFI registration. Content and tools are for education and general guidance only. Investments are subject to market risks.";

export const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/risk-disclosure", label: "Risk Disclosure" },
  { to: "/regulatory-disclosures", label: "Regulatory Disclosures" },
];
